import React from 'react';
import { Card } from '../components/ui/Card';
export function MenuPage() {
  const bbqItems = [{
    name: 'Pulled Pork Sandwich',
    price: '$8.99',
    desc: 'Slow-smoked for 12 hours, served on a brioche bun'
  }, {
    name: 'Beef Brisket Plate',
    price: '$14.99',
    desc: 'Tender slices of brisket with two sides'
  }, {
    name: 'Ribs (Half Rack)',
    price: '$16.99',
    desc: 'Fall-off-the-bone St. Louis style ribs'
  }, {
    name: 'Smoked Chicken',
    price: '$10.99',
    desc: 'Quarter chicken with our signature rub'
  }];
  const sides = [{
    name: 'Mac & Cheese',
    price: '$3.99'
  }, {
    name: 'Coleslaw',
    price: '$2.99'
  }, {
    name: 'Baked Beans',
    price: '$3.99'
  }, {
    name: 'Potato Salad',
    price: '$3.99'
  }];
  return <div className="max-w-6xl mx-auto px-4 py-12" data-id="element-266">
      <div className="text-center mb-16" data-id="element-267">
        <h1 className="text-4xl md:text-6xl font-retro text-white mb-4" data-id="element-268">
          The Menu
        </h1>
        <p className="text-xl text-gray-400" data-id="element-269">
          Fresh from the BBQ Train every Thursday!
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12" data-id="element-270">
        {/* BBQ Section */}
        <div data-id="element-271">
          <h2 className="text-3xl font-retro text-primary mb-6 flex items-center" data-id="element-272">
            <span className="mr-4" data-id="element-273">🔥</span> From The Smoker
          </h2>
          <div className="space-y-6" data-id="element-274">
            {bbqItems.map(item => <Card key={item.name} className="p-6 hover:bg-dark-lighter transition-colors" data-id="element-275">
                <div className="flex justify-between items-start mb-2" data-id="element-276">
                  <h3 className="text-xl font-bold text-white" data-id="element-277">{item.name}</h3>
                  <span className="text-primary font-bold font-retro" data-id="element-278">
                    {item.price}
                  </span>
                </div>
                <p className="text-gray-400 text-sm" data-id="element-279">{item.desc}</p>
              </Card>)}
          </div>
        </div>

        {/* Sides & Drinks */}
        <div data-id="element-280">
          <h2 className="text-3xl font-retro text-secondary mb-6 flex items-center" data-id="element-281">
            <span className="mr-4" data-id="element-282">🥗</span> Sides & Extras
          </h2>
          <div className="grid grid-cols-1 gap-4" data-id="element-283">
            {sides.map(item => <div key={item.name} className="flex justify-between items-center p-4 border-b border-gray-800" data-id="element-284">
                <span className="text-lg text-gray-200" data-id="element-285">{item.name}</span>
                <span className="text-secondary font-bold" data-id="element-286">{item.price}</span>
              </div>)}
          </div>

          <div className="mt-12 p-6 bg-dark-card rounded-xl border border-gray-800" data-id="element-287">
            <h3 className="text-xl font-retro text-white mb-4" data-id="element-288">
              Convenience Store Staples
            </h3>
            <ul className="list-disc list-inside text-gray-400 space-y-2" data-id="element-289">
              <li data-id="element-290">Fresh Coffee & Fountain Drinks</li>
              <li data-id="element-291">Beer & Wine Selection</li>
              <li data-id="element-292">Snacks, Chips & Candy</li>
              <li data-id="element-293">Ice & Propane</li>
              <li data-id="element-294">Lottery Tickets</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}